const locale = {
  DUPLICATE_OF: 'Másolata ennek',
  DUPLICATED_BY: 'Másolva általa',
  RELATED_TO: 'Kapcsolódik ehhez',
  SPLIT_TO: 'Felosztva ide',
  SPLIT_FROM: 'Felosztva innen',
  BLOCKED_BY: 'Blokkolva általa',
  BLOCKS: 'Blokkolja',
  MORE_THAN: 'Nagyobb mint',
  LESS_THAN: 'Kisebb mint',
  OPEN: 'Nyitott',
  IN_PROGRESS: 'Folyamatban',
  ON_HOLD: 'Várakozik',
  COMPLETE: 'Befejezett',
  'home.built': 'Karbantartás-kezelés Egyszerűsítésére Építve',
  home_description:
    'Amikor a táblák és ragacsos jegyzetek káoszt okoznak, és szükséged van egy CMMS szoftverre, amely elég egyszerű ahhoz, hogy a csapatod ténylegesen használja - próbáld ki a {{shortBrandName}}-t',
  try_grash: '{{shortBrandName}} Kipróbálása',
  login: 'Bejelentkezés',
  start_trial: 'Ingyenes Próbaidőszak Indítása',
  'home.what': 'Mit',
  'home.you_will_have': 'Lesz neked',
  'home.you_will_have_description':
    'Építs hatékony, megbízható munkafolyamatokat, amelyek irányítást adnak a karbantartás felett. Generálj, rendelj ki és kövesd nyomon a munkarendeléseket. Irányítsd a készletet. És kapj megbízható automatizált jelentéseket, amelyek javítják a láthatóságot és felelősségvállalást teremtenek.',
  key_features: 'Főbb Funkciók',
  key_features_description:
    'Néhány olyan funkció, amely a {{shortBrandName}}-t az egyik legjobb ma elérhető CMMS-sé teszi',
  contribute: 'Hozzájárulás',
  work_orders: 'Munkarendelések',
  request_system: 'Munkakérelem Rendszer',
  mobile_app: 'Mobil Alkalmazás',
  asset_management: 'Eszközkezelés',
  preventive_maintenance: 'Megelőző Karbantartás',
  parts_inventory: 'Alkatrész Készlet',
  custom_dashboards: 'Egyedi Műszerfalak',
  'work-orders.title': 'Kezeld a Munkarendeléseidet Profi Módon',
  'work-orders.description.short':
    'Tekintsd meg és Kezeld az összes Feladatodat',
  'work-orders.descriptions.0':
    'Elegendő a papírmunkák tömegéből és az elveszett Munkarendelésekből? Mindezek az elveszett tételek közvetlenül befolyásolják a nyereséget és a hírnevedet.',
  'work-orders.descriptions.1':
    'A {{shortBrandName}} segítségével könnyedén és gyorsan szervezheted az összes Munkarendelésedet, PM-jeidet és egyéb Feladataidat a csapatodban egy központosított adatbázisban, amely bárhol, bármilyen eszközön elérhető.',
  'work-orders.checks.0':
    'Tekintsd meg az összes Feladatodat, beleértve a WO-kat, PM-eket és Munkakérelmeket',
  'work-orders.checks.1':
    'Állítsd be a Feladat prioritását, hogy a megfelelő munka kerüljön először elvégzésre.',
  'work-orders.checks.2':
    'Tekintsd meg a jelenlegi és közelgő Feladatok naptárát.',
  'work-orders.checks.3':
    'Tekintsd meg a munkakijelöléseket kritikus információkkal, mint az Eszköz információk, határidő, prioritás és egyebek.',
  'work-orders.checks.4':
    'Tekintsd meg a kritikus KPI-kat, mint a ténylegesen befejezett munka, eltöltött idő és tervezett vs nem tervezett munka.',

  'work-requests.title': 'Egyszerűsített mobil munkakérelem rendszer',
  'work-requests.descriptions.0':
    'Elegendő a régi telefon és e-mail rendszer használatából, amely ELVESZETT jegyeket, állandó napi megszakításokat és duplikált munkát eredményez?',
  'work-requests.descriptions.1':
    'A {{shortBrandName}} karbantartás-kezelési megoldása lehetővé teszi bárki számára, akit feljogosítasz, hogy problémát jelentsen a karbantartási részlegnek egyszerűen egy QR-kód (vonalkód) beolvasásával vagy egy URL meglátogatásával és kérésük beírásával mobil eszközeiken keresztül.',
  'work-requests.checks.0': 'Soha ne veszíts el Munkát.',
  'work-requests.checks.1':
    'Csökkentsd a Munkakérelmek kezelésére fordított időt akár 34%-kal.',
  'work-requests.checks.2':
    'Csökkentsd a Kérelmezőkkel való kommunikációra fordított időt akár 41%-kal (hívások, e-mailek, üzenetek).',

  'mobile-app.title':
    'Mobil CMMS alkalmazás, amely erősíti a karbantartási csapatodat',
  'mobile-app.descriptions.0':
    'Android mobil alkalmazásunk használatával ügyfeleink jobb szervezést, kommunikációt, felelősségvállalást és akár 30%-kal nagyobb produktivitást tapasztalnak az egész karbantartási csapatukban.',
  'mobile-app.descriptions.1':
    'Kézi eszközükről a karbantartási csapatod bármelyik tagja képes:',
  'mobile-app.checks.0':
    'Megtekinteni a hozzájuk rendelt Munkarendeléseket és PM-eket.',
  'mobile-app.checks.1': 'Naplózni Munkarendeléseiket 60 másodpercen belül',
  'mobile-app.checks.2':
    'Azonnali kommunikációt kapni push és e-mail értesítéseken keresztül.',
  'mobile-app.checks.3':
    'Új Munkarendeléseket indítani, miközben a terepen vannak.',
  'mobile-app.checks.4':
    'Reagálni és naplózni problémákat, miközben ténylegesen a probléma megoldásán dolgoznak',
  'mobile-app.checks.5':
    'Kritikus eszközinformációkat keresni, miközben problémát diagnosztizálnak.',

  'eam.title': 'Vállalati Eszközkezelés',
  'eam.description.short': 'Ismerd az eszközeidet',
  'eam.descriptions.0':
    'Frusztrált vagy a vállalati berendezések kaotikus rendetlenségének szervezésével, azon töprengve, hogy a berendezést megfelelően karbantartották-e, nem tudva, mennyibe kerül a karbantartásuk és minden egyéb fejfájással, ami az eszközök kezelésével jár?',
  'eam.descriptions.1':
    'A {{brandName}} Vállalati Eszközkezelési modulja 10-től 1.000.000 Eszközig használható, lehetővé téve, hogy pontosan azt kövesd nyomon, amit akarsz, ahogy akarod, egy könnyen használható és kereshető fastruktúrában.',
  'eam.checks.0':
    'Ismerd az eszközeid állapotát minden időpontban és azt, hogy mennyibe kerülnek',
  'eam.checks.1': 'Tekintsd meg a teljes és részletes Karbantartási Naplókat.',
  'eam.checks.2':
    'Csak azt kövesd nyomon, amit akarsz, korlátlan egyedi mezőkkel',
  'eam.checks.3': 'Szervezd az eszközeidet világos szülő-gyermek hierarchiában',
  'eam.checks.4':
    'Találj információkat gyorsan és egyszerűen QR-kódokkal (vonalkódok)',
  'eam.checks.5': 'Kapj valós idejű eszközadatokat szenzor kapcsolattal.',

  'pm.title': 'Hatékony Megelőző Karbantartási Program',
  'pm.descriptions.0':
    'Hagyd abba az értékes órák pazarlását a PM ellenőrzőlisták kézi terjesztésével és a csapatoddal való utánkövetéssel, hogy megbizonyosodj a munka elvégzéséről.',
  'pm.descriptions.1':
    'A {{shortBrandName}} lehetővé teszi a PM ütemezés egyszerű automatizálását, így a megfelelő munka automatikusan a megfelelő időben kerül kiszállításra a megfelelő technikushoz a megfelelő Eszközhöz.',
  'pm.checks.0':
    'Automatizáld a PM ütemezést napi, heti, havi, éves alapon, vagy események vagy mérőleolvasások alapján.',
  'pm.checks.1':
    'Automatikus push és e-mail értesítések, amikor PM létrejön vagy esedékes.',
  'pm.checks.2':
    'Könnyen használható Naptárunk lehetővé teszi az összes nyitott munka és közelgő PM ütemezések megtekintését.',
  'pm.checks.3': 'Húzd és ejtsd a határidő módosításához.',
  'pm.checks.4':
    'PM befejezésekor a munka automatikusan naplózásra kerül az eszköz karbantartási naplójában.',
  'pm.checks.5': 'Kevés vagy semmilyen képzést nem igényel a használathoz.',

  'part.title': 'Szerezd meg a Pótalkatrész Készleted Irányítását',
  'part.description.short': 'Tudd, mikor fogynak el az alkatrészeid',
  'part.descriptions.0':
    'Nem vagy biztos benne, milyen alkatrészeid vannak raktáron vagy hol használják őket? Nem tudod, mikor fogynak el az alkatrészeid, vagy hogy a technikusaidnak megvannak-e a szükséges alkatrészek a munkájuk elvégzéséhez?',
  'part.descriptions.1':
    'A {{shortBrandName}} alkatrészkezelését úgy terveztük, hogy megoldja ezeket a problémákat és még többet:',
  'part.checks.0':
    'Kapj azonnali push és e-mail értesítéseket, amikor egy alkatrész mennyisége alacsony. Tartsd a megfelelő számú alkatrészt raktáron azonnali és automatikus push/e-mail értesítések kapásával, amikor egy alkatrész mennyisége egy egyedileg beállított küszöb alatt van.',
  'part.checks.1':
    'A technikusok azonnal tudják, hogy az alkatrész raktáron van-e egy Munkarendelésen belülről. Ha az alkatrész nincs raktáron, könnyen ellenőrizhetik más helyszíneket, hogy elérhető-e.',
  'part.checks.2':
    'Automatikus alkatrészhasználat követés. Ahogy a Munkarendelések vagy PM-ek alkatrészeket használnak, a készlet automatikusan frissül, hogy tükrözze a használt alkatrészeket.',
  'part.checks.3':
    'Ismerd az alkatrészhasználatot. Tekintsd meg az Alkatrész Naplót, hogy lásd, hol használják az alkatrészt és ki által',
  'part.checks.4':
    'Elimináld a nem használt alkatrészeket. Tudd, mikor vált egy alkatrész elavulttá.',
  'part.checks.5':
    'Valós Idejű Jelentések. Tudd, milyen alkatrészeket használnak hol és mennyibe kerülnek.',
  'part.checks.6':
    'Optimalizáld a készletszinteket. Azonnal tekintsd meg egy alkatrész előrejelzését, hogy lásd, hány alkatrészt használhatnak a következő évben.',
  'part.checks.7':
    'Vonalkód keresés. Tedd könnyen követhetővé és elérhetővé a készletedet egyedi QR-kódokkal',

  'dashboard.title': 'Az adataid, a módodra egyedi műszerfalakkal',
  'dashboard.descriptions.0':
    'Nézzünk szembe vele, az első lépés a működésed javításához az, hogy ismerd a jót, a rosszat és a csúnyát.',
  'dashboard.descriptions.1':
    'A {{shortBrandName}} Egyedi Műszerfaljaival végre elkezdheted megérteni azt a hírhedt "karbantartás fekete lyukát" és elkezdheted adatokkal alátámasztott tervek végrehajtását, ami csökkentett munkaerőköltségeket, csökkentett állásidőt és még többet eredményez.',
  'dashboard.descriptions.2': 'A {{shortBrandName}} Egyedi Műszerfaljaival ...',
  'dashboard.checks.0': 'Tudd, hova költik a pénzedet és miért',
  'dashboard.checks.1': 'Tudd, melyik eszköz kerül a legtöbbe és miért',
  'dashboard.checks.2': 'Hozz létre saját egyedi KPI-kat.',
  'dashboard.checks.3':
    'Tekintsd meg a jelentéseket, amelyek automatikusan generálódnak és frissülnek a metrikáid alapján',
  'dashboard.checks.4':
    'Tekintsd meg a jelentéseket, amelyek könnyen megoszthatók Excel táblázatokon, PDF-eken vagy a {{shortBrandName}}-n belül',
  'dashboard.checks.5': 'És még sok más ...',
  'home.smarter': 'Okosabb',
  'home.work': 'Munka',
  'home.smarter_description':
    'A {{shortBrandName}} hihetetlenül egyszerűvé teszi a technikusok számára a hatékony munkát azáltal, hogy hozzáférést biztosít számukra az eszközökhöz és adatokhoz, amelyekre szükségük van a munka elvégzéséhez — mindezt a tenyerükből.',
  leading_maintenance:
    'Vezető Út a Jobb Jövő Felé a Karbantartás és Megbízhatóság Terén',
  //register
  premium_included: 'Prémium funkciók mellékelve',
  no_credit_card: 'Hitelkártya nem szükséges',
  perfect_tool: 'A tökéletes eszköz Karbantartási csapatoknak',
  start_trial_today: 'Indítsd el az Ingyenes próbaidőszakot ma',
  create_account: 'Fiók létrehozása',
  signup_description: 'Töltsd ki az alábbi mezőket a fiók regisztrációjához.',
  account_already: 'Már van fiókod?',
  signin_here: 'Jelentkezz be itt',
  invalid_email: 'A megadott e-mail címnek érvényes e-mail címnek kell lennie',
  required_email: 'Az e-mail mező kötelező',
  required_firstName: 'A keresztnév mező kötelező',
  required_lastName: 'A vezetéknév mező kötelező',
  required_company: 'A cégnév mező kötelező',
  required_employeesCount: 'Kérjük, add meg az alkalmazottak számát',
  invalid_phone: 'A telefonszám érvénytelen',
  required_password: 'A jelszó mező kötelező',
  required_terms: 'El kell fogadnod a feltételeinket',
  verify_email: 'Kérjük, ellenőrizd az e-mailedet a fiókod aktiválásához',
  registration_error: 'A regisztráció nem sikerült',
  first_name: 'Keresztnév',
  last_name: 'Vezetéknév',
  email: 'E-mail cím',
  phone: 'Telefon',
  password: 'Jelszó',
  companyName: 'Cégnév',
  employeesCount: 'Alkalmazottak Száma',
  i_accept: 'Elfogadom a',
  terms_conditions: 'feltételeket',
  create_your_account: 'Hozd létre a fiókodat',
  register: 'Regisztráció',
  //signin
  login_description:
    'Töltsd ki az alábbi mezőket a fiókodba való bejelentkezéshez.',
  no_account_yet: 'Még nincs fiókod?',
  signup_here: 'Regisztrálj itt',
  wrong_credentials: 'Hibás bejelentkezési adatok',
  lost_password: 'Elfelejtett jelszó?',
  //work-orders
  link_wo: 'Munkarendelés Összekapcsolása',
  link_wo_description: 'Kapcsolatok létrehozása Munkarendelések között',
  required_relationType: 'Válassz kapcsolattípust.',
  required_wo: 'Munkarendelés mező kötelező.',
  this_wo: 'Ez a Munkarendelés',
  the_wo: 'A Munkarendelés',
  link: 'Összekapcsolás',
  cost_description: 'Költség leírása',
  assigned_to: 'Hozzárendelve',
  category: 'Kategória',
  date: 'Dátum',
  cost: 'Költség',
  include_cost: 'Vedd bele ezt a költséget a teljes költségbe',
  include_cost_description:
    'Ez hozzáadja a költséget a Munkarendelésre fordított teljes költséghez',
  required_cost_description: 'Költség leírása kötelező',
  required_cost: 'Költség kötelező',
  add_cost: 'Extra Költségek Hozzáadása',
  add_cost_description:
    'Töltsd ki az alábbi mezőket Extra Költségek létrehozásához és hozzáadásához',
  add: 'Hozzáadás',
  hourly_rate: 'Órabér',
  include_time: 'Vedd bele ezt az időt a teljes időbe',
  include_time_description:
    'Ez hozzáadja az időtartamot a Munkarendelésre fordított teljes időhöz',
  work_started_at: 'Munka Elkezdve',
  duration: 'Időtartam',
  hours: 'Órák',
  minutes: 'Percek',
  required_hours: 'Órák mező kötelező',
  required_minutes: 'Percek mező kötelező',
  add_time: 'Idő Hozzáadása',
  add_time_description:
    'Töltsd ki az alábbi mezőket Idő létrehozásához és hozzáadásához',
  feedback: 'Visszajelzés',
  feedback_description: 'Add meg a visszajelzésedet',
  required_feedback: 'Visszajelzés kötelező',
  signature: 'Aláírás',
  required_signature: 'Kép kötelező',
  close_wo: 'Munkarendelés Lezárása',
  close: 'Lezárás',
  task_update_success: 'Feladat sikeresen frissítve',
  task_update_failure: 'A feladat nem frissíthető',
  notes_save_success: 'Jegyzetek sikeresen mentve',
  images_add_task_success: 'A képek hozzáadva a feladathoz',
  images_add_task_failure: 'Valami hiba történt',
  images: 'Képek',
  required_images: 'Tölts fel legalább egy képet',
  add_images: 'Képek Hozzáadása',
  tasks: 'Feladatok',
  wo_archive_success: 'A Munkarendelés archiválva',
  wo_archive_failure: 'A Munkarendelés nem archiválható',
  wo_archive_confirm:
    'Biztos vagy benne, hogy archiválni akarod ezt a Munkarendelést ',
  quantity_change_success: 'Mennyiség sikeresen módosítva',
  quantity_change_failure: 'A mennyiség nem módosítható',
  details: 'Részletek',
  updates: 'Frissítések',
  id: 'ID',
  due_date: 'Határidő',
  location: 'Helyszín',
  asset: 'Eszköz',
  team: 'Csapat',
  created_at: 'Létrehozva',
  list_view: 'Lista nézet',
  calendar_view: 'Naptár nézet',
  column_view: 'Oszlop nézet',
  wo_create_success: 'A Munkarendelés sikeresen létrehozva',
  wo_create_failure: 'A Munkarendelés nem hozható létre',
  changes_saved_success: 'A változtatások mentve',
  wo_update_failure: 'A Munkarendelés nem szerkeszthető',
  wo_delete_success: 'A Munkarendelés sikeresen törölve',
  wo_delete_failure: 'A Munkarendelés nem törölhető',
  status: 'Állapot',
  title: 'Cím',
  priority: 'Prioritás',
  description: 'Leírás',
  worker: 'Dolgozó',
  location_name: 'Helyszín neve',
  location_address: 'Helyszín címe',
  asset_name: 'Eszköz neve',
  days_since_creation: 'Napok a létrehozás óta',
  files: 'Fájlok',
  requested_by: 'Kérelmező',
  completed_on: 'Befejezve',
  updated_at: 'Frissítve',
  work_order: 'Munkarendelés',
  timer_running: 'Időmérő fut',
  run_timer: 'Időmérő Indítása',
  approved_by: 'Jóváhagyta',
  created_by: 'Létrehozta',
  completed_by: 'Befejezte',
  time: 'Idő',
  save: 'Mentés',
  customers: 'Vállalkozók',
  no_labor:
    'Még nincsenek munkaerőköltségek hozzáadva. Itt fognak megjelenni, amikor egy felhasználó időt naplóz és órabére van mentve a {{brandName}}-ben.',
  not_assigned: 'Nincs Hozzárendelve',
  no_additional_cost: 'Még nincsenek Extra költségek hozzáadva',
  parts: 'Alkatrészek',
  links: 'Kapcsolatok',
  confirm_delete_file_wo:
    'Biztos vagy benne, hogy törölni akarod ezt a fájlt ebből a Munkarendelésből?',
  archive: 'Archiválás',
  labors: 'Munkaerő',
  add_additional_cost: 'Extra Költségek hozzáadása',
  additional_costs: 'Extra Költségek',
  add_parts: 'Alkatrészek Hozzáadása',
  'wo.title_description': 'Add meg a Munkarendelés címét',
  image: 'Kép',
  estimated_duration: 'Becsült Időtartam Órákban',
  primary_worker: 'Elsődleges Dolgozó',
  additional_workers: 'További Dolgozók',
  select_team: 'Csapat kiválasztása',
  select_location: 'Helyszín kiválasztása',
  select_asset: 'Eszköz kiválasztása',
  select_tasks: 'Feladatok Kiválasztása',
  requires_signature: 'Aláírás Szükséges',
  required_wo_title: 'Munkarendelés címe kötelező',
  add_wo: 'Munkarendelés Hozzáadása',
  add_wo_description:
    'Töltsd ki az alábbi mezőket új Munkarendelés létrehozásához és hozzáadásához',
  edit_wo: 'Munkarendelés Szerkesztése',
  edit_wo_description:
    'Töltsd ki az alábbi mezőket a Munkarendelés frissítéséhez',
  'noRows.wo.message':
    'A Munkarendelések olyan feladatok vagy munkák, amelyek ütemezhetők vagy hozzárendelhetők valakihez',
  'noRows.wo.action': "Nyomd meg a '+' gombot Munkarendelés létrehozásához",
  to_delete: 'Törlés',
  confirm_delete_wo:
    'Biztos vagy benne, hogy törölni akarod ezt a Munkarendelést?',
  no_access_wo:
    'Nincs hozzáférésed a Munkarendelésekhez. Lépj kapcsolatba az adminisztrátorral, ha hozzáférésed kellene legyen',
  cancel: 'Mégse',
  select_parts: 'Alkatrészek Kiválasztása',
  sets_of_parts: 'Alkatrész Készletek',
  //preventive maintenance
  paused: 'Szüneteltetve',
  trigger_details: 'Trigger Részletek',
  starts_on: 'Kezdődik',
  ends_on: 'Végződik',
  frequency: 'Gyakoriság',
  every_frequency_days: 'Minden {{frequency}} nap',
  wo_details: 'Munkarendelés Részletek',
  confirm_delete_file: 'Biztos vagy benne, hogy törölni akarod ezt a fájlt?',
  wo_schedule_success: 'Munkarendelés sikeresen ütemezve',
  wo_schedule_failure: 'A munkarendelés nem ütemezhető',
  pm_create_success: 'A Megelőző Karbantartás sikeresen létrehozva',
  pm_create_failure: 'A Megelőző Karbantartás nem hozható létre',
  pm_edit_failure: 'A Megelőző Karbantartás nem szerkeszthető',
  pm_delete_success: 'A Megelőző Karbantartás sikeresen törölve',
  pm_delete_failure: 'A Megelőző Karbantartás nem törölhető',
  pm_name: 'PM név',
  enter_pm_name: 'Add meg a PM nevét',
  required_pm_name: 'PM név kötelező',
  add_pm: 'Megelőző Karbantartás Hozzáadása',
  add_pm_description:
    'Töltsd ki az alábbi mezőket új Megelőző Karbantartás létrehozásához és hozzáadásához',
  edit_pm: 'Megelőző Karbantartás Szerkesztése',
  edit_pm_description:
    'Töltsd ki az alábbi mezőket a Megelőző Karbantartás szerkesztéséhez',
  confirm_delete_pm:
    'Biztos vagy benne, hogy törölni akarod ezt a Megelőző Karbantartást?',
  'noRows.pm.message':
    'A Megelőző Karbantartások ismétlődő feladatok, amelyek segítenek az eszközeid karbantartásában',
  'noRows.pm.action':
    "Nyomd meg a '+' gombot Megelőző Karbantartás létrehozásához",
  no_access_pm:
    'Nincs hozzáférésed a Megelőző Karbantartáshoz. Lépj kapcsolatba az adminisztrátorral, ha hozzáférésed kellene legyen',
  //assets
  asset_create_success: 'Az Eszköz sikeresen létrehozva',
  asset_create_failure: 'Az Eszköz nem hozható létre',
  asset_edit_failure: 'Az Eszköz nem szerkeszthető',
  asset_delete_success: 'Az Eszköz sikeresen törölve',
  asset_delete_failure: 'Az Eszköz nem törölhető',
  name: 'Név',
  model: 'Modell',
  serial_number: 'Sorozatszám',
  warranty_expiration_date: 'Garancia Lejárati Dátuma',
  additional_information: 'További Információk',
  enter_asset_name: 'Add meg az eszköz nevét',
  enter_asset_model: 'Add meg az eszköz modelljét',
  enter_asset_description: 'Add meg az eszköz leírását',
  enter_asset_serial_number: 'Add meg az eszköz sorozatszámát',
  enter_asset_additional_information: 'Add meg az eszköz további információit',
  required_asset_name: 'Eszköz neve kötelező',
  add_asset: 'Eszköz Hozzáadása',
  add_asset_description:
    'Töltsd ki az alábbi mezőket új Eszköz létrehozásához és hozzáadásához',
  edit_asset: 'Eszköz Szerkesztése',
  edit_asset_description:
    'Töltsd ki az alábbi mezőket az Eszköz szerkesztéséhez',
  confirm_delete_asset:
    'Biztos vagy benne, hogy törölni akarod ezt az Eszközt?',
  asset_details: 'Eszköz Részletek',
  parent_asset: 'Szülő Eszköz',
  child_assets: 'Gyermek Eszközök',
  no_child_asset: 'Nincs gyermek eszköz',
  no_file_in_asset: 'Nincs Fájl kapcsolva ehhez az eszközhöz',
  no_wo_in_asset: 'Nincs Munkarendelés ebben az eszközben',
  barcode: 'Vonalkód',
  enter_asset_barcode: 'Add meg az eszköz vonalkódját',
  area: 'Terület',
  enter_asset_area: 'Add meg az eszköz területét',
  //locations
  location_create_success: 'A Helyszín sikeresen létrehozva',
  location_create_failure: 'A Helyszín nem hozható létre',
  location_edit_failure: 'A Helyszín nem szerkeszthető',
  location_delete_success: 'A Helyszín sikeresen törölve',
  location_delete_failure: 'A Helyszín nem törölhető',
  address: 'Cím',
  enter_location_name: 'Add meg a helyszín nevét',
  enter_location_address: 'Add meg a helyszín címét',
  required_location_name: 'Helyszín neve kötelező',
  add_location: 'Helyszín Hozzáadása',
  add_location_description:
    'Töltsd ki az alábbi mezőket új Helyszín létrehozásához és hozzáadásához',
  edit_location: 'Helyszín Szerkesztése',
  edit_location_description:
    'Töltsd ki az alábbi mezőket a Helyszín szerkesztéséhez',
  confirm_delete_location:
    'Biztos vagy benne, hogy törölni akarod ezt a Helyszínt?',
  location_details: 'Helyszín Részletek',
  parent_location: 'Szülő Helyszínek',
  child_locations: 'Gyermek Helyszínek',
  no_child_location: 'Nincs gyermek helyszín',
  floor_plan: 'Alaprajz',
  add_floor_plan: 'Új Alaprajz hozzáadása',
  add_floor_plan_description:
    'Töltsd ki az alábbi mezőket új Alaprajz létrehozásához',
  no_asset_in_location: 'Nincs eszköz ezen a helyszínen',
  no_wo_in_location: 'Nincs Munkarendelés ezen a helyszínen',
  no_file_in_location: 'Nincs Fájl kapcsolva ehhez a helyszínhez',
  no_floor_plan_in_location: 'Nincs Alaprajz ezen a helyszínen',
  assigned_teams: 'Hozzárendelt Csapatok',
  assigned_customers: 'Hozzárendelt Vállalkozók',
  assigned_vendors: 'Hozzárendelt Szállítók',
  //no_access
  no_access_location:
    'Nincs hozzáférésed a Helyszínekhez. Lépj kapcsolatba az adminisztrátorral, ha hozzáférésed kellene legyen',
  no_access_vendors_customers:
    'Nincs hozzáférésed a Szállítókhoz és Vállalkozókhoz. Lépj kapcsolatba az adminisztrátorral, ha hozzáférésed kellene legyen',
  no_access_people_team:
    'Nincs hozzáférésed az Emberekhez és Csapatokhoz. Lépj kapcsolatba az adminisztrátorral, ha hozzáférésed kellene legyen',
  no_access_analytics:
    'Nincs hozzáférésed az Analitikához. Lépj kapcsolatba az adminisztrátorral, ha hozzáférésed kellene legyen',
  no_access_assets:
    'Nincs hozzáférésed az Eszközökhöz. Lépj kapcsolatba az adminisztrátorral, ha hozzáférésed kellene legyen',
  no_access_categories:
    'Nincs hozzáférésed a Kategóriákhoz. Lépj kapcsolatba az adminisztrátorral, ha hozzáférésed kellene legyen',
  no_access_files:
    'Nincs hozzáférésed a Fájlokhoz. Lépj kapcsolatba az adminisztrátorral, ha hozzáférésed kellene legyen',
  no_access_inventory:
    'Nincs hozzáférésed a Készlethez. Lépj kapcsolatba az adminisztrátorral, ha hozzáférésed kellene legyen',
  no_access_meters:
    'Nincs hozzáférésed a Mérőkhöz. Lépj kapcsolatba az adminisztrátorral, ha hozzáférésed kellene legyen',
  no_access_purchase_orders:
    'Nem hozhatsz létre Beszerzési Rendelést. Lépj kapcsolatba az adminisztrátorral, ha hozzáférésed kellene legyen',
  no_access_requests:
    'Nincs hozzáférésed a Kérelmekhez. Lépj kapcsolatba az adminisztrátorral, ha hozzáférésed kellene legyen',
  no_access_settings:
    'Nincs hozzáférésed a beállításokhoz. Lépj kapcsolatba az adminisztrátorral, ha hozzáférésed kellene legyen',
  no_access_page: 'Nincs hozzáférésed ehhez az oldalhoz',
  file: 'Fájl',
  'noRows.location.message':
    'A Helyszínek lehetővé teszik az eszközök és dolgozók hatékonyabb kezelését',
  'noRows.location.action': "Nyomd meg a '+' gombot Helyszín létrehozásához",
  //inventory
  card_view: 'Kártya nézet',
  set_create_success: 'A Készlet sikeresen létrehozva',
  set_create_failure: 'A Készlet nem hozható létre',
  set_edit_failure: 'A Készlet nem szerkeszthető',
  set_delete_success: 'A Készlet sikeresen törölve',
  set_delete_failure: 'A Készlet nem törölhető',
  total_cost: 'Teljes Költség',
  part: 'Alkatrész',
  enter_part_name: 'Add meg az Alkatrész nevét',
  required_set_name: 'Készlet neve kötelező',
  add_set: 'Készlet Hozzáadása',
  add_set_description:
    'Töltsd ki az alábbi mezőket új Készlet létrehozásához és hozzáadásához',
  create_set: 'Készlet Létrehozása',
  edit_set: 'Készlet Szerkesztése',
  edit_set_description: 'Töltsd ki az alábbi mezőket a Készlet szerkesztéséhez',
  confirm_delete_set: 'Biztos vagy benne, hogy törölni akarod ezt a Készletet?',
  part_create_success: 'Az Alkatrész sikeresen létrehozva',
  part_create_failure: 'Az Alkatrész nem hozható létre',
  part_edit_failure: 'Az Alkatrész nem szerkeszthető',
  part_delete_success: 'Az Alkatrész sikeresen törölve',
  part_delete_failure: 'Az Alkatrész nem törölhető',
  quantity: 'Mennyiség',
  open_wo: 'Nyitott Munkarendelések',
  enter_part_category: 'Add meg az Alkatrész kategóriáját',
  enter_part_cost: 'Add meg az Alkatrész költségét',
  enter_part_quantity: 'Add meg az Alkatrész mennyiségét',
  minimum_quantity: 'Minimum Mennyiség',
  enter_part_minimum_quantity: 'Add meg az alkatrész minimum mennyiségét',
  non_stock: 'Nem Raktáron',
  enter_part_barcode: 'Add meg az Alkatrész Vonalkódját',
  enter_part_area: 'Add meg az Alkatrész Területét',
  additional_part_details: 'További Alkatrész Részletek',
  add_part: 'Alkatrész Hozzáadása',
  add_part_description:
    'Töltsd ki az alábbi mezőket új Alkatrész létrehozásához és hozzáadásához',
  create_part: 'Alkatrész Létrehozása',
  update_part: 'Alkatrész Frissítése',
  update_part_description:
    'Töltsd ki az alábbi mezőket az Alkatrész frissítéséhez',
  'noRows.part.message':
    'Az alkatrészek eszközökké kombinálhatók vagy egyedül használhatók',
  'noRows.part.action': "Nyomd meg a '+' gombot Alkatrész létrehozásához",
  confirm_delete_part:
    'Biztos vagy benne, hogy törölni akarod ezt az Alkatrészt?',
  part_details: 'Alkatrész részletek',
  area_details: 'Terület részletek',
  assigned_people: 'Hozzárendelt emberek',
  no_asset_related_part: 'Nincs eszköz kapcsolva ehhez az alkatrészhez',
  no_file_found: 'Nincs Fájl találva',
  no_wo_found: 'Nincs Munkarendelés találva',
  workers: 'Dolgozók',
  Parts_and_Inventory: 'Alkatrészek és Készlet',
  //purchase order
  po_edit_failure: 'A Beszerzési Rendelés nem szerkeszthető',
  po_delete_success: 'A Beszerzési Rendelés sikeresen törölve',
  po_delete_failure: 'A Beszerzési Rendelés nem törölhető',
  number_of_items: 'Tételek száma',
  total_quantity: 'Teljes Mennyiség',
  shipping_to: 'Szállítás ide',
  shipping_address: 'Szállítási Cím',
  po_details: 'Beszerzési Rendelés Részletek',
  enter_po_name: 'Add meg a Beszerzési Rendelés nevét',
  additional_details: 'További Részletek',
  vendor: 'Szállító',
  shipping_information: 'Szállítási Információk',
  company_name: 'Cégnév',
  ship_to: 'Szállítás Címzettje',
  city: 'Város',
  state: 'Állam',
  zip_code: 'Irányítószám',
  fax_number: 'Fax Szám',
  po_date: 'Beszerzési Rendelés Dátuma',
  notes: 'Jegyzetek',
  add_notes: 'Jegyzetek Hozzáadása',
  requisitioner: 'Igénylő',
  terms: 'Feltételek',
  shipping_method: 'Szállítási Mód',
  required_name: 'A név kötelező',
  edit_po: 'Beszerzési Rendelés Szerkesztése',
  edit_po_description:
    'Töltsd ki az alábbi mezőket a Beszerzési Rendelés frissítéséhez',
  purchase_order: 'Beszerzési Rendelés',
  'noRows.po.message': 'Kezeld a Beszerzési Rendeléseidet egy helyen',
  'noRows.po.action':
    "Nyomd meg a '+' gombot Beszerzési Rendelés létrehozásához.",
  confirm_delete_po:
    'Biztos vagy benne, hogy törölni akarod ezt a Beszerzési Rendelést?',
  upgrade_po: 'Frissítés Beszerzési Rendelések létrehozásához',
  new_po: 'Új Beszerzési Rendelés',
  po_create_success: 'A Beszerzési Rendelés sikeresen létrehozva',
  select_one_part: 'Válassz ki legalább 1 alkatrészt ',
  po_create_failure: 'A Beszerzési Rendelés nem hozható létre',
  approve_while_submitting: 'Jóváhagyás beküldés közben',
  invalid_fax: 'A fax szám érvénytelen',
  submit: 'Beküldés',
  each_item_superior_zero:
    'Minden Tétel mennyiségének 0-nál nagyobbnak kell lennie',
  quantity_edit_success: 'Mennyiség sikeresen módosítva',
  quantity_edit_failure: 'A mennyiség nem módosítható',
  APPROVED: 'Jóváhagyva',
  PENDING: 'Függőben',
  REJECTED: 'Elutasítva',
  //meter
  when_reading_is: 'Amikor a Mérő Leolvasás',
  greater_than: 'Nagyobb mint',
  lower_than: 'Kisebb mint',
  value: 'Érték',
  required_value: 'Az érték kötelező',
  required_trigger_condition: 'A feltétel kötelező',
  wo_trigger_create_success: 'A Munkarendelés trigger sikeresen létrehozva',
  wo_trigger_create_failure: 'A Munkarendelés trigger nem hozható létre',
  add_wo_trigger: 'Munkarendelés Trigger Hozzáadása',
  add_wo_trigger_description:
    'Töltsd ki az alábbi mezőket Munkarendelés Trigger létrehozásához és hozzáadásához',
  wo_trigger_edit_success: 'A Munkarendelés trigger sikeresen frissítve',
  meter_create_success: 'A mérő sikeresen létrehozva',
  meter_create_failure: 'A mérő nem hozható létre ',
  meter_edit_failure: 'A mérő nem szerkeszthető',
  meter_delete_success: 'A mérő sikeresen törölve',
  meter_delete_failure: 'A mérő nem törölhető',
  next_reading_due: 'Következő Leolvasás Esedékes',
  unit_of_measurement: 'Mértékegység',
  last_reading: 'Utolsó Leolvasás',
  enter_meter_name: 'Add meg a Mérő nevét',
  unit: 'Egység',
  update_frequency: 'Frissítési Gyakoriság',
  update_frequency_in_days: 'Frissítési gyakoriság napokban',
  required_meter_name: 'Mérő neve kötelező',
  required_meter_unit: 'Mérő egysége kötelező',
  required_meter_update_frequency: 'Mérő frissítési gyakorisága kötelező',
  required_asset: 'Eszköz kötelező',
  add_meter: 'Mérő Hozzáadása',
  add_meter_description:
    'Töltsd ki az alábbi mezőket új Mérő létrehozásához és hozzáadásához',
  edit_meter: 'Mérő Szerkesztése',
  edit_meter_description: 'Töltsd ki az alábbi mezőket a Mérő szerkesztéséhez',
  confirm_delete_meter: 'Biztos vagy benne, hogy törölni akarod ezt a Mérőt?',
  upgrade_create_meter: 'Frissítés Mérők létrehozásához',
  history: 'Történet',
  reading_frequency: 'Leolvasási Gyakoriság',
  required_reading_value: 'Leolvasási érték kötelező',
  wo_triggers: 'Munkarendelés Triggerek',
  add_trigger: 'Trigger Hozzáadása',
  meter_details: 'Mérő részletek',
  'noRows.meter.message':
    'A mérő leolvasások lehetővé teszik az eszközök monitorozását és új munkarendelések triggerelését meghatározott feltételek alapján',
  'noRows.meter.action': "Nyomd meg a '+' gombot Mérő létrehozásához",
  meter: 'Mérő',
  //upload
  drag_one_file: 'Húzz egy egyedi fájlt ide',
  drag_many_files: 'Húzd & ejtsd a fájlokat ide',
  drop_to_start: 'Ejtsd le a fájlokat a feltöltés megkezdéséhez',
  invalid_files_type: 'Ezeket a fájltípusokat nem töltheted fel',
  you_have_uploaded: 'Feltöltötted',
  upload: 'Feltöltés',
  //vendors_customers
  Vendors_Customers: 'Szállítók és Vállalkozók',
  customer_create_success: 'A Vállalkozó sikeresen létrehozva',
  customer_create_failure: 'A Vállalkozó nem hozható létre',
  customer_edit_failure: 'A Vállalkozó nem szerkeszthető',
  customer_delete_success: 'A Vállalkozó sikeresen törölve',
  customer_delete_failure: 'A Vállalkozó nem törölhető',
  customer_name: 'Vállalkozó Neve',
  website: 'Weboldal',
  customer_type: 'Vállalkozó típusa',
  customer_type_description: 'pl. Vízvezeték-szerelés, Elektromos',
  customer_description_description:
    'Írd le ennek a vállalkozónak a célját néhány sorban...',
  billing_information: 'Számlázási Információk',
  address_line_2: '2. Címsor',
  billing_name: 'Számlázási Név',
  currency: 'Pénznem',
  select_currency: 'Pénznem Kiválasztása',
  required_customer_name: 'Vállalkozó Neve kötelező',
  required_phone: 'A telefonszám kötelező',
  invalid_website: 'Érvénytelen weboldal',
  billing_address: 'Számlázási Cím',
  add_customer: 'Vállalkozó Hozzáadása',
  add_customer_description:
    'Töltsd ki az alábbi mezőket új vállalkozó létrehozásához és hozzáadásához',
  'noRows.customer.message': 'A vállalkozók külső dolgozók',
  'noRows.customer.action': "Nyomd meg a '+' gombot Vállalkozó létrehozásához",
  type: 'Típus',
  billing_currency: 'Számlázási Pénznem',
  go_back: 'Vissza',
  confirm_delete_customer:
    'Biztos vagy benne, hogy törölni akarod ezt a Vállalkozót?',
  //vendor
  vendor_create_success: 'A Szállító sikeresen létrehozva',
  vendor_create_failure: 'A Szállító nem hozható létre',
  vendor_edit_failure: 'A Szállító nem szerkeszthető',
  vendor_delete_success: 'A Szállító sikeresen törölve',
  vendor_delete_failure: 'A Szállító nem törölhető',
  required_company_name: 'Cégnév kötelező',
  vendor_type: 'Szállító Típusa',
  contact_name: 'Kapcsolattartó neve',
  add_vendor: 'Szállító hozzáadása',
  add_vendor_description:
    'Töltsd ki az alábbi mezőket új szállító létrehozásához és hozzáadásához',
  confirm_delete_vendor:
    'Biztos vagy benne, hogy törölni akarod ezt a Szállítót?',
  'noRows.vendor.message':
    'A szállítók olyan szervezetek, amelyek Eszközöket vagy Alkatrészeket biztosítanak',
  'noRows.vendor.action': "Nyomd meg a '+' gombot Szállító létrehozásához",
  vendor_type_description: 'pl. Vízvezeték-szerelés, Elektromos',
  //people teams
  role: 'Szerep',
  edit_user: 'Felhasználó Szerkesztése',
  edit_user_description:
    'Töltsd ki az alábbi mezőket a felhasználó szerkesztéséhez',
  job_title: 'Beosztás',
  invite_users: 'Felhasználók Meghívása',
  bring_people_team: 'Hozz új embereket a csapatba',
  add_20_users:
    "20 felhasználót adhatsz hozzá egyszerre a 'tab' vagy 'enter' megnyomásával minden e-mail bevitel után. Bármilyen duplikátum és regisztrált e-mail cím eltávolításra kerül a kért felhasználók regisztrációjakor.",
  enter_email: 'Add meg az e-mail címet',
  users_invite_success: 'Felhasználók meghívva',
  users_invite_failure:
    'A felhasználók nem hívhatók meg. Ellenőrizd a jelenlegi előfizetésed tagszámát',
  please_type_emails: 'Írj be e-mail címeket a meghíváshoz',
  please_select_role: 'Válassz egy szerepet',
  invite: 'Meghívás',
  team_create_success: 'A Csapat sikeresen létrehozva',
  team_create_failure: 'A Csapat nem hozható létre',
  team_edit_failure: 'A Csapat nem szerkeszthető',
  team_delete_success: 'A Csapat sikeresen törölve',
  team_delete_failure: 'A Csapat nem törölhető',
  team_name: 'Csapat neve',
  people_in_team: 'Emberek a csapatban',
  required_team_name: 'Csapat neve kötelező',
  create_team: 'Csapat létrehozása',
  create_team_description: 'Innen adhatsz hozzá csapattagokat',
  confirm_delete_team: 'Biztos vagy benne, hogy törölni akarod ezt a Csapatot?',
  overview: 'Áttekintés',
  activity: 'Tevékenység',
  wo_complete_last_14_days: 'Munkarendelések befejezve az elmúlt 14 napban',
  no_wo_complete_last_14_days:
    'Nem fejeztél be munkarendeléseket az elmúlt két hétben',
  ADMIN_name: 'Adminisztrátor',
  ADMIN_description:
    'Az adminisztrátor teljes hozzáféréssel rendelkezik; beleértve a munkarendelések és kérelmek szerkesztését, hozzáadását, törlését',
  LIMITED_ADMIN_name: 'Korlátozott Adminisztrátor',
  LIMITED_ADMIN_description:
    'A korlátozott adminisztrátorok ugyanolyan hozzáféréssel rendelkeznek, mint az adminisztrátor, kivéve hogy nem tekinthetik meg/szerkeszthetik a beállításokat vagy nem adhatnak hozzá/szerkeszthetnek embereket és csapatokat. Nem törölhetnek Munkarendeléseket, Eszközöket, Helyszíneket, Mérőket és Beszerzési Rendeléseket, kivéve ha ők hozták létre a Vállalkozókat, Kategóriákat és PM triggereket.',
  TECHNICIAN_name: 'Technikus',
  TECHNICIAN_description:
    'A technikus létrehozhat és lezárhat munkarendeléseket, eszközöket és helyszíneket. Csak azt szerkesztheti és törölheti, amit ő hozott létre',
  LIMITED_TECHNICIAN_name: 'Korlátozott Technikus',
  LIMITED_TECHNICIAN_description:
    'A korlátozott technikusok csak a hozzájuk rendelt munkarendeléseket láthatják',
  VIEW_ONLY_name: 'Csak Megtekintés',
  VIEW_ONLY_description:
    'A csak megtekintés felhasználók teljes megtekintési hozzáféréssel rendelkeznek, de semmit sem szerkeszthetnek',
  REQUESTER_name: 'Kérelmező',
  REQUESTER_description:
    'A kérelmezők csak munkakérelmeket nyújthatnak be és megtekinthetik azok állapotát',
  select_user_role: 'Felhasználói szerep kiválasztása',
  'noRows.team.message':
    'A csapatok segítenek az emberek specifikus csoportjainak kezelésében.',
  'noRows.team.action': "Nyomd meg a '+' gombot csapat létrehozásához.",
  user_details: 'Felhasználó részletek',
  //files
  file_delete_success: 'A fájl sikeresen törölve',
  file_delete_failure: 'A fájl nem törölhető',
  uploaded_by: 'Feltöltötte',
  uploaded_on: 'Feltöltve',
  rename: 'Átnevezés',
  required_files: 'Tölts fel legalább egy fájlt',
  required_file_name: 'Add meg a fájl nevét',
  add_files: 'Fájlok Hozzáadása',
  edit_file: 'Fájl Szerkesztése',
  'noRows.file.message': 'Szerezd meg Az összes fájlt Egy helyen',
  'noRows.file.action': "Nyomd meg a '+' gombot Fájl feltöltéséhez",
  upgrade_files:
    'Frissítés a fájlok használatához az Eszközeidben, Munkarendeléseidben, Helyszíneidben stb...',
  parts_consumption: 'Alkatrészfogyasztás',
  requests_analysis: 'Kérelmek elemzése',
  //categories,
  category_create_success: 'A Kategória sikeresen létrehozva',
  category_create_failure: 'A Kategória nem hozható létre',
  category_edit_failure: 'A Kategória nem szerkeszthető',
  category_delete_success: 'A Kategória sikeresen törölve',
  category_delete_failure: 'A Kategória nem törölhető',
  timers: 'Időmérők',
  costs: 'Költségek',
  add_category: 'Új kategória hozzáadása',
  add_category_description:
    'Töltsd ki a nevet új kategória létrehozásához és hozzáadásához',
  edit_category: 'Kategória Szerkesztése',
  edit_category_description: 'Töltsd ki a nevet a kategória szerkesztéséhez',
  no_category_action:
    "Nyomd meg a '+' gombot az első kategóriád hozzáadásához.",
  confirm_delete_category:
    'Biztos vagy benne, hogy törölni akarod ezt a Kategóriát?',
  no_category_message: 'Úgy tűnik, még nincsenek {{categoryName}} Kategóriáid.',
  acquisition_cost: 'Beszerzési költség',
  //settings
  general_settings: 'Általános Beállítások',
  request_form_configuration: 'Kéreleműrlap konfiguráció',
  roles: 'Szerepek',
  checklists: 'Ellenőrzőlisták',
  field_configuration_description:
    'Megjelölheted a mezőket Opcionálisként, Rejtettként vagy Kötelezőként',
  optional: 'Opcionális',
  required: 'Kötelező',
  hidden: 'Rejtett',
  creating_wo: 'Munkarendelés létrehozása',
  completing_wo: 'Munkarendelés befejezése',
  role_edit_failure: 'A szerep nem szerkeszthető',
  edit_role: 'Szerep szerkesztése',
  edit_role_description: 'Töltsd ki az alábbi mezőket a szerep szerkesztéséhez',
  external_id: 'Külső ID',
  permissions: 'Engedélyek',
  create_role_description:
    'Ez a szerep mindent megtehet, amit egy Adminisztrátor megtehet a {{brandName}}-ben, de néhány fontos engedélyt alább testreszabhatsz.',
  create_and_edit: 'Létrehozás/Szerkesztés',
  to_access: 'Hozzáféréshez',
  to_create_edit: 'Létrehozáshoz/szerkesztéshez',
  checklist_create_success: 'Az Ellenőrzőlista sikeresen létrehozva',
  checklist_create_failure: 'Az Ellenőrzőlista nem hozható létre',
  checklist_edit_failure: 'Az Ellenőrzőlista nem szerkeszthető',
  checklist_delete_success: 'Az Ellenőrzőlista sikeresen törölve',
  checklist_delete_failure: 'Az Ellenőrzőlista nem törölhető',
  checklist_name: 'Ellenőrzőlista neve',
  enter_checklist_name: 'Add meg az ellenőrzőlista nevét',
  required_checklist_name: 'Ellenőrzőlista neve kötelező',
  add_checklist: 'Ellenőrzőlista Hozzáadása',
  add_checklist_description:
    'Töltsd ki az alábbi mezőket új Ellenőrzőlista létrehozásához és hozzáadásához',
  edit_checklist: 'Ellenőrzőlista Szerkesztése',
  edit_checklist_description:
    'Töltsd ki az alábbi mezőket az Ellenőrzőlista szerkesztéséhez',
  confirm_delete_checklist:
    'Biztos vagy benne, hogy törölni akarod ezt az Ellenőrzőlistát?',
  'noRows.checklist.message':
    'Az ellenőrzőlisták segítenek a munka szabványosításában',
  'noRows.checklist.action':
    "Nyomd meg a '+' gombot Ellenőrzőlista létrehozásához",
  task_type: 'Feladat típusa',
  task_label: 'Feladat címke',
  enter_task_label: 'Add meg a feladat címkéjét',
  task_options: 'Feladat opciók',
  enter_task_options: 'Add meg a feladat opcióit',
  add_task_option: 'Feladat opció hozzáadása',
  task_notes: 'Feladat jegyzetek',
  enter_task_notes: 'Add meg a feladat jegyzeteit',
  SUBTASK: 'Alfeladat',
  INSPECTION: 'Ellenőrzés',
  METER: 'Mérő',
  MULTIPLE: 'Többszörös',
  NUMBER: 'Szám',
  TEXT: 'Szöveg',
  upgrade_checklist: 'Frissítés Ellenőrzőlisták létrehozásához',
  learn_more: 'Tudj meg többet',
  //user profile
  profile: 'Profil',
  email_notifications: 'E-mail értesítések',
  email_updates_wo: 'E-mail frissítések Munkarendelésekhez és Értesítésekhez',
  email_updates_requests: 'E-mail frissítések Kért Munkarendelésekhez',
  po_emails: 'Beszerzési Rendelés E-mail',
  required_job_title: 'A beosztás mező kötelező',
  required_old_password: 'Add meg a jelenlegi jelszót.',
  invalid_password: 'A jelszó túl rövid - legalább 8 karakternek kell lennie.',
  required_new_password: 'Nincs jelszó megadva.',
  passwords_must_match: 'A jelszavaknak egyezniük kell',
  password_change_success: 'Jelszó sikeresen módosítva',
  wrong_password: 'Hibás jelszó megadva',
  current_password: 'Jelenlegi jelszó',
  new_password: 'Új jelszó',
  confirm_password: 'Jelszó megerősítése',
  personal_details: 'Személyes Adatok',
  personal_details_description:
    'Kezeld a személyes adataidhoz kapcsolódó információkat',
  change_password: 'Jelszó módosítása',
  notification_settings: 'Értesítési beállítások',
  notification_settings_description:
    'Kezeld az értesítéseidhez kapcsolódó részleteket',
  recent_activity: 'Legutóbbi Tevékenység',
  created: 'Létrehozva',
  completed: 'Befejezve',
  my_account: 'Fiókom',
  my_company: 'Cégem',
  you_are_using_plan:
    'Jelenleg a {{planName}} csomagot használod. {{expiration}} napon jár le. Frissíts most, hogy több funkcióhoz férj hozzá.',
  upgrade_plan: 'Csomag Frissítése',
  //subscription
  plans: 'Csomagok',
  monthly: 'Havi',
  annually: 'Éves',
  subscription_change_success: 'Az Előfizetés sikeresen módosítva',
  invalid_credit_card: 'A hitelkártya szám érvénytelen',
  required_credit_card: 'A kártya mező kötelező',
  invalid_expiration_month: 'A lejárati hónap érvénytelen',
  required_expiration_month: 'A Lejárati hónap kötelező',
  invalid_expiration_year: 'A lejárati év érvénytelen',
  required_expiration_year: 'A Lejárati év kötelező',
  invalid_cvv: 'A CVV érvénytelen',
  required_cvv: 'A CVV kötelező',
  required_cardholder_name: 'A kártyatulajdonos neve kötelező',
  card: 'Kártya',
  expiration_month: 'Lejárati Hónap',
  expiration_year: 'Lejárati Év',
  cardholder_name: 'Kártyatulajdonos neve',
  seats: 'Helyek',
  cost_per_seat: 'Költség helyenként',
  your_payment_secure: 'A fizetési adataid titkosítva és biztonságban vannak.',
  plan: 'Csomag',
  current_plan: 'Jelenlegi Csomag',
  number_users_who_will_use_grash:
    'A {{shortBrandName}}-t használó felhasználók száma',
  admin_role: 'Admin',
  technical_role: 'Technikai',
  limited_technical_role: 'Korlátozott Technikai',
  requester_role: 'Kérelmező',
  view_only_role: 'Csak-Megtekintés',
  how_will_you_be_billed: 'Hogyan szeretnél számlázni?',
  which_plan_fits_you: 'Melyik csomag illik hozzád a legjobban?',
  per_user_month: 'felhasználónként/hó',
  per_user_year: 'felhasználónként/év',
  you_will_be_charged: 'Számlázva leszel',
  proceed_to_payment: 'Tovább a Fizetéshez',
  pay_only_for_roles:
    'Csak az <strong>Admin</strong>, <strong>Technikai</strong> és <strong>Korlátozott Technikai</strong> felhasználókért fizess, és használj korlátlan <strong>Kérelmező</strong>, <strong>Csak-Megtekintés</strong> felhasználót ingyen',
  checkout_our: 'Nézd meg a',
  pricing_page: 'Árképzési Oldalt',
  for_more_details: 'további részletekért',
  users_count_display: '{{count}} Felhasználó',
  monthly_adverb: 'havonta',
  yearly_adverb: 'évente',
  features: 'Funkciók',
  checkout: 'Pénztár',
  checkout_description: 'Töltsd ki az alábbi mezőket',
  per_month: 'havonta',
  per_year: 'évente',
  recover_password_description:
    'Add meg a regisztrációhoz használt e-mail címet a jelszavad visszaállításához.',
  send_me_new_password: 'Küldj új jelszót',
  want_to_sign_in_again: 'Szeretnél újra bejelentkezni?',
  check_mails_for_instructions:
    'Ellenőrizd az e-mailedet további utasításokért',
  pdf_report: 'PDF Jelentés',
  HIGH: 'Magas',
  MEDIUM: 'Közepes',
  LOW: 'Alacsony',
  NONE: 'Nincs',
  import: 'Importálás',
  start_import_process: 'Importálási Folyamat Indítása',
  import_data: 'Adatok Importálása',
  set_header: 'Fejléc Beállítása',
  match_columns: 'Oszlopok Egyeztetése',
  review: 'Áttekintés',
  done: 'Kész',
  no_match_yet: 'Még Nincs Egyezés',
  select: 'Kiválasztás...',
  matched_to_field: 'Egyeztetve a {{field}} mezővel',
  next: 'Következő',
  not_enough_rows: 'Nincs elég sor a fájlban',
  there_are_duplicates: 'Duplikátumok vannak: {{duplicates}}',
  assigned_by: 'Hozzárendelte',
  percent_rows_have_value: 'A sorok {{percent}}%-ának van értéke',
  match_at_least_column: 'Legalább egy oszlopot egyeztess',
  to_import: 'Importálás',
  required_match: '{{field}} egyeztetése kötelező',
  archived: 'Archiválva',
  import_wo_success:
    '{{created}} Munkarendelés létrehozva és {{updated}} frissítve',
  to_export: 'Exportálás',
  filters: 'Szűrők',
  more_filters: 'További Szűrők',
  customer: 'Vállalkozó',
  to: 'ide',
  dates: 'Dátumok',
  start: 'Kezdés',
  end: 'Vég',
  longitude: 'Hosszúság',
  latitude: 'Szélesség',
  ALL: 'Összes',
  REACTIVE: 'Reaktív',
  REPEATING: 'Megelőző',
  import_location_success:
    '{{created}} Helyszín létrehozva és {{updated}} frissítve',
  import_part_success:
    '{{created}} Alkatrész létrehozva és {{updated}} frissítve',
  import_meter_success: '{{created}} Mérő létrehozva és {{updated}} frissítve',
  import_asset_success:
    '{{created}} Eszköz létrehozva és {{updated}} frissítve',
  wo_calendar: 'Munkarendelések Naptára',
  month: 'Hónap',
  week: 'Hét',
  day: 'Nap',
  agenda: 'Napirend',
  previous: 'Előző',
  today: 'Ma',
  to_filter: 'Szűrés',
  'noRows.asset.message':
    'Az eszközök olyan erőforrások, amelyekbe a vállalat beavatkozhat',
  'noRows.asset.action': "Nyomd meg a '+' gombot új Eszköz létrehozásához.",
  reset_filters: 'Szűrők Visszaállítása',
  toggle_menu: 'Menü Váltása',
  no_results: 'Nincs találat',
  an_error_occured: 'Hiba történt.',
  density: 'Sűrűség',
  compact: 'Kompakt',
  standard: 'Szabványos',
  comfortable: 'Kényelmes',
  columns: 'Oszlopok',
  select_columns: 'Oszlopok kiválasztása',
  show_filters: 'Szűrők megjelenítése',
  hide_filters: 'Szűrők elrejtése',
  search_placeholder: 'Keresés…',
  search: 'Keresés',
  clear: 'Törlés',
  download_as_csv: 'Letöltés CSV-ként',
  print: 'Nyomtatás',
  download_as_excel: 'Letöltés Excel-ként',
  find_column: 'Oszlop keresése',
  column_title: 'Oszlop címe',
  reorder_column: 'Oszlop átrendezése',
  show_all: 'Összes megjelenítése',
  hide_all: 'Összes elrejtése',
  add_filter: 'Szűrő hozzáadása',
  logic_operator: 'Logikai operátor',
  operator: 'Operátor',
  and: 'És',
  or: 'Vagy',
  filter_value: 'Szűrő értéke',
  contains: 'tartalmazza',
  equals: 'egyenlő',
  starts_with: 'kezdődik',
  ends_with: 'végződik',
  is: 'az',
  is_not: 'nem',
  is_after: 'után van',
  is_on_or_after: 'ekkor vagy után van',
  is_before: 'előtt van',
  is_on_or_before: 'ekkor vagy előtt van',
  is_empty: 'üres',
  is_not_empty: 'nem üres',
  is_any_of: 'bármelyike',
  any: 'bármely',
  true_text: 'igaz',
  false_text: 'hamis',
  menu: 'Menü',
  show_columns: 'Oszlopok megjelenítése',
  hide: 'Elrejtés',
  unsort: 'Rendezés megszüntetése',
  sort_by_ASC: 'Rendezés ASC szerint',
  sort_by_DESC: 'Rendezés DESC szerint',
  sort: 'Rendezés',
  total_rows: 'Összes Sor:',
  yes: 'Igen',
  no: 'Nem',
  more: 'Több',
  to_group: 'Csoportosítás',
  see_children: 'gyermekek megtekintése',
  hide_children: 'gyermekek elrejtése',
  expand: 'Kibontás',
  collapse: 'Összecsukás',
  detail_panel_toggle: 'Részletek panel váltó',
  cancel_subscription: 'Előfizetés Lemondása',
  resume_subscription: 'Előfizetés Folytatása',
  confirm_cancel_subscription:
    'Biztos vagy benne, hogy le akarod mondani az előfizetést?',
  workflows: 'Munkafolyamatok',
  create_workflow: 'Munkafolyamat Létrehozása',
  if: 'Ha',
  and_optional: 'És(Opcionális)',
  then: 'Akkor',
  workflow_description:
    'Hozz létre egyedi munkafolyamatokat olyan egyszerűen, mint Ha, És, Akkor. Takarítsd meg az időt és rendeld hozzá automatikusan a munkarendeléseidet munkafolyamatokon keresztül, hogy testreszabd a {{shortBrandName}}-t a csapatod működési módjához.\nMinden csomag létrehozhat 1 egyedi munkafolyamatot. További munkafolyamatok hozzáadásához frissíts az Üzleti csomagunkra',
  CREATE_PURCHASE_ORDER: 'Beszerzési Rendelés létrehozása',
  PART_IS: 'Az Alkatrész',
  QUANTITY_INFERIOR: 'A mennyiség kevesebb mint',
  ASSIGN_VENDOR: 'Szállító hozzárendelése',
  ASSIGN_CATEGORY: 'Kategória hozzárendelése',
  APPROVE: 'Jóváhagyás',
  REJECT: 'Elutasítás',
  SEND_REMINDER_EMAIL: 'Emlékeztető e-mail küldése',
  VENDOR_IS: 'A szállító',
  CATEGORY_IS: 'A kategória',
  STATUS_IS: 'Az állapot',
  DUE_DATE_BETWEEN: 'A Határidő között van',
  DUE_DATE_AFTER: 'A Határidő után van',
  ASSIGN_PRIORITY: 'Prioritás hozzárendelése',
  ASSIGN_ASSET: 'Eszköz hozzárendelése',
  ASSIGN_LOCATION: 'Helyszín hozzárendelése',
  ASSIGN_USER: 'Felhasználó hozzárendelése',
  ASSIGN_TEAM: 'Csapat hozzárendelése',
  ADD_CHECKLIST: 'Ellenőrzőlista hozzáadása',
  PRIORITY_IS: 'A prioritás',
  ASSET_IS: 'Az eszköz',
  LOCATION_IS: 'A helyszín',
  USER_IS: 'A felhasználó',
  TEAM_IS: 'A csapat',
  CREATED_AT_BETWEEN: 'Létrehozva között',
  TITLE_CONTAINS: 'A cím tartalmazza',
  CREATE_REQUEST: 'Kérelem létrehozása',
  CREATE_WORK_ORDER: 'Munkarendelés létrehozása',
  SET_ASSET_STATUS: 'Eszköz állapot beállítása',
  NAME_IS: 'A név',
  NAME_CONTAINS: 'A név tartalmazza',
  VALUE_IS: 'Az érték',
  VALUE_CONTAINS: 'Az érték tartalmazza',
  NUMBER_VALUE_SUPERIOR: 'Az érték nagyobb mint',
  NUMBER_VALUE_INFERIOR: 'Az érték kisebb mint',
  WORK_ORDER_CREATED: 'Munkarendelés létrehozva',
  WORK_ORDER_CLOSED: 'Munkarendelés lezárva',
  WORK_ORDER_ARCHIVED: 'Munkarendelés archiválva',
  REQUEST_CREATED: 'Kérelem létrehozva',
  REQUEST_APPROVED: 'Kérelem jóváhagyva',
  REQUEST_REJECTED: 'Kérelem elutasítva',
  PURCHASE_ORDER_CREATED: 'Beszerzési rendelés létrehozva',
  PURCHASE_ORDER_UPDATED: 'Beszerzési rendelés frissítve',
  TASK_UPDATED: 'Feladat frissítve',
  PART_UPDATED: 'Alkatrész frissítve',
  add_condition: 'Feltétel hozzáadása',
  workflow_creation_success: 'Munkafolyamat sikeresen létrehozva',
  workflow_creation_failure: 'A munkafolyamat létrehozása nem sikerült',
  action_value_missing: 'A művelet értéke hiányzik',
  condition_value_missing: 'Egy feltétel értéke hiányzik',
  workflow_edit_success: 'A munkafolyamat sikeresen frissítve',
  workflow_edit_failure: 'A munkafolyamat nem szerkeszthető',
  workflow_delete_success: 'A munkafolyamat sikeresen törölve',
  workflow_delete_failure: 'A munkafolyamat nem törölhető',
  confirm_delete_workflow:
    'Biztos vagy benne, hogy törölni akarod ezt a munkafolyamatot',
  click_here: 'Kattints ide',
  verify_email_title: 'E-mail Ellenőrzése',
  verify_email_description:
    'Ellenőrző e-mail lett küldve neked. Ellenőrizd a spam mappát, ha nem látod a bejövő levelek között.',
  upgrade: 'Frissítés',
  downgrade: 'Visszaminősítés',
  upgrade_description:
    'Éppen frissítetted az előfizetési csomagodat. Engedélyezned kell a letiltott felhasználókat, akik használhatják a {{shortBrandName}}-t. Ezt csak egyszer teheted meg a jelenlegi előfizetéshez. Válassz gondosan',
  enable_users: 'Felhasználók engedélyezése',
  max_users_description: 'Legfeljebb {{maxUsers}} felhasználót engedélyezhetsz',
  downgrade_description:
    'Éppen visszaminősítetted az előfizetési csomagodat. Le kell tiltanod néhány felhasználót a folytatáshoz. Ezt csak egyszer teheted meg a jelenlegi előfizetéshez. Válassz gondosan',
  disable_users: 'Felhasználók letiltása',
  min_users_description: 'Legalább {{minUsers}} felhasználót le kell tiltanod',
  downgrade_description_no_owner:
    'A céged éppen visszaminősítette az előfizetési csomagját. A cégtulajdonosnak le kell tiltania néhány felhasználót, mielőtt folytathatnád',
  past_due: 'Lejárt',
  due_date_delay: 'Határidő késleltetés',
  due_date_delay_description: 'Határidő késleltetés napokban',
  days_count: '{{days}} nap',
  trigger_configuration: 'Trigger Konfiguráció',
  WORK_ORDER_feature: 'Munkarendelések',
  REQUEST_feature: 'Munkakérelmek',
  PART_feature: 'Alkatrészkezelés',
  MOBILE_APP_feature: 'Mobil Alkalmazás',
  WORK_ORDER_HISTORY_feature: 'Munkarendelések Történet',
  PREVENTIVE_MAINTENANCE_feature: 'Megelőző Karbantartás',
  CHECKLIST_feature: 'Ellenőrzőlisták',
  FILE_feature: 'Fájl Feltöltések',
  PURCHASE_ORDER_feature: 'Beszerzési Rendelések',
  METER_feature: 'Mérő Leolvasások',
  REQUEST_CONFIGURATION_feature: 'Kéreleműrlap konfiguráció',
  ADDITIONAL_TIME_feature: 'Fejlett Időkövetés',
  ADDITIONAL_COST_feature: 'Fejlett Költségkövetés',
  ANALYTICS_feature: 'Analitika és Jelentések',
  REQUEST_PORTAL_feature: 'Kérelem Portál',
  SIGNATURE_feature: 'Aláírások',
  ROLE_feature: 'Egyedi szerepek',
  WORKFLOW_feature: 'Munkafolyamat automatizálás',
  API_ACCESS_feature: 'API hozzáférés',
  WEBHOOK_feature: 'Webhookok',
  add_new_option: 'Új Opció hozzáadása',
  edit_company: 'Cég szerkesztése',
  fill_fields_below: 'Töltsd ki az alábbi mezőket',
  IMPORT_CSV_feature: 'CSV importálás',
  no_import_access:
    'Frissítsd a csomagodat CSV, Excel fájlokból való importáláshoz',
  register_here: 'Regisztrálj itt',
  home: 'Kezdőlap',
  user: 'Felhasználó',
  start_work_order: 'Munkarendelés Indítása',
  priority_label: '{{priority}} prioritás',
  stop_work_order: 'Időmérő leállítása',
  required_files_on_completion:
    'Fájlok szükségesek a Munkarendelés Befejezéséhez',
  required_tasks_on_completion: 'A feladatokat be kell fejezni',
  required_labor_on_completion: 'Időt kell naplóznod',
  required_part_on_completion:
    'Nincs Alkatrész használva ebben a Munkarendelésben',
  required_cost_on_completion:
    'Nincs Költséginformáció megadva ebben a Munkarendelésben',
  complete_work_order: 'Munkarendelés Befejezése',
  no_parts: 'Nincs alkatrész',
  edit_quantity: 'Mennyiség szerkesztése',
  remaining_tasks: '{{count}} fennmaradó feladat',
  complete_tasks_percent: '{{percent}}% befejezve',
  create_work_order: 'Munkarendelés Létrehozása',
  select_customers: 'Ügyfelek Kiválasztása',
  select_vendors: 'Szállítók Kiválasztása',
  select_users: 'Felhasználók Kiválasztása',
  select_teams: 'Csapatok Kiválasztása',
  select_locations: 'Helyszínek Kiválasztása',
  select_assets: 'Eszközök Kiválasztása',
  select_categories: 'Kategóriák Kiválasztása',
  estimated_hours_in_text: '{{hours}} becsült óra',
  create_meter: 'Mérő Létrehozása',
  create_location: 'Helyszín Létrehozása',
  create_request: 'Kérelem Létrehozása',
  add_task: 'Feladat Hozzáadása',
  select_task_type: 'Feladat típus kiválasztása',
  assign_user: 'Felhasználó Hozzárendelése',
  assign_asset: 'Eszköz Hozzárendelése',
  add_options: 'Opciók hozzáadása',
  required_task_label: 'A feladat címke kötelező',
  edit_work_order: 'Munkarendelés Szerkesztése',
  confirmation: 'Megerősítés',
  LATE_WO: 'Késő',
  TODAY_WO: 'Ma',
  HIGH_WO: 'Magas prioritás',
  no_element_match_criteria: 'Nincs elem, amely megfelel ennek a kritériumnak',
  required_part_name: 'Alkatrész neve kötelező',
  only_assigned_to_me: 'Csak hozzám rendelve',
  complete_work_orders: 'Munkarendelések Befejezése',
  this_week: 'Ezen a héten',
  all_time: 'Minden idő',
  compliant_work_orders: 'Megfelelő Munkarendelések',
  stats: 'Statisztikák',
  vendors_and_customers: 'Szállítók és Vállalkozók',
  no_notification_message:
    'A fontos frissítések itt fognak megjelenni, hogy segítsenek a munkád előrehaladásának nyomon követésében',
  no_notification: 'Nincs értesítés',
  view_children: 'Gyermekek megtekintése',
  loading: 'Betöltés',
  please_wait: 'Kérlek várj...',
  add_file: 'Fájl hozzáadása',
  asset_update_failure: 'Az Eszköz nem szerkeszthető',
  no_wo_linked_location: 'Nincs Munkarendelés ezen a helyszínen',
  confirm_delete_file_location:
    'Biztos vagy benne, hogy törölni akarod ezt a fájlt erről a helyszínről?',
  confirm_delete_file_part:
    'Biztos vagy benne, hogy törölni akarod ezt a fájlt erről az alkatrészről?',
  no_wo_linked_part: 'Nincs Munkarendelés kapcsolva ehhez az alkatrészhez',
  edit_customer: 'Vállalkozó szerkesztése',
  edit_vendor: 'Szállító szerkesztése',
  reading_history: 'Leolvasási történet',
  user_invite_success: 'A felhasználó meghívva',
  user_invite_failure: 'A felhasználó nem hívható meg',
  create_child_asset: 'Gyermek eszköz létrehozása',
  not_enough_part: 'Nincs elég ebből az alkatrészből',
  update_profile: 'Profil frissítése',
  confirm_logout: 'Biztos vagy benne, hogy ki akarsz jelentkezni?',
  report: 'Jelentés',
  end_cannot_be_ulterior_to_start:
    'A befejezési dátum nem lehet korábbi a kezdési dátumnál',
  storage_permission_needed_description:
    'Tárolási engedélyt kell adnod a fájl letöltéséhez',
  permission_denied: 'Engedély Megtagadva!',
  to_scan: 'Szkennelés',
  nfc_tag: 'NFC címke',
  scanning: 'Szkennelés',
  error: 'Hiba',
  tag_not_found: 'Címke nem található',
  'no nfc support': 'Nincs NFC támogatás',
  remaining_parts: '{{quantity}} maradt',
  team_members_count: '{{count}} tag',
  no_asset_found_nfc:
    'Nincs Eszköz találva ezzel az NFC címkével. Szeretnéd létrehozni?',
  no_access_to_camera: 'Nincs hozzáférés a kamerához',
  no_asset_found_barcode:
    'Nincs Eszköz találva ezzel a vonalkóddal. Szeretnéd létrehozni?',
  remove_blank_meter_tasks: 'Válassz egy mérőt',
  no_notification_permission: 'Nincs Értesítési Engedély',
  OPERATIONAL: 'Működőképes',
  DOWN: 'Leállt',
  MODERNIZATION: 'Modernizálás',
  STANDBY: 'Készenlét',
  INSPECTION_SCHEDULED: 'Ellenőrzés Ütemezve',
  COMMISSIONING: 'Üzembe helyezés',
  EMERGENCY_SHUTDOWN: 'Vészleállítás',
  asset_status: 'Eszköz állapot',
  downtime_duration: 'Állásidő időtartama',
  downtime_duration_in_hours: 'Állásidő időtartama órákban',
  downtime_duration_in_days: 'Állásidő időtartama napokban',
  downtime_duration_in_minutes: 'Állásidő időtartama percekben',
  asset_status_change_success: 'Eszköz állapot sikeresen módosítva',
  asset_status_change_failure: 'Az eszköz állapot nem módosítható',
  set_asset_status: 'Eszköz Állapot Beállítása',
  set_asset_status_description: 'Állítsd be az eszköz állapotát',
  asset_status_history: 'Eszköz Állapot Történet',
  no_asset_status_history: 'Nincs eszköz állapot történet',
  asset_status_changed_to: 'Eszköz állapot módosítva erre: {{status}}',
  asset_status_changed_by: 'Eszköz állapot módosítva általa: {{user}}',
  asset_status_changed_on: 'Eszköz állapot módosítva ekkor: {{date}}',
  asset_status_changed_from_to:
    'Eszköz állapot módosítva erről: {{from}} erre: {{to}}',
  asset_status_changed_from_to_by:
    'Eszköz állapot módosítva erről: {{from}} erre: {{to}} általa: {{user}}',
  asset_status_changed_from_to_on:
    'Eszköz állapot módosítva erről: {{from}} erre: {{to}} ekkor: {{date}}',
  asset_status_changed_from_to_by_on:
    'Eszköz állapot módosítva erről: {{from}} erre: {{to}} általa: {{user}} ekkor: {{date}}',
  asset_status_changed_from_to_by_on_with_downtime:
    'Eszköz állapot módosítva erről: {{from}} erre: {{to}} általa: {{user}} ekkor: {{date}} állásidővel: {{downtime}}',
  asset_status_changed_from_to_on_with_downtime:
    'Eszköz állapot módosítva erről: {{from}} erre: {{to}} ekkor: {{date}} állásidővel: {{downtime}}',
  asset_status_changed_from_to_by_with_downtime:
    'Eszköz állapot módosítva erről: {{from}} erre: {{to}} általa: {{user}} állásidővel: {{downtime}}',
  asset_status_changed_from_to_with_downtime:
    'Eszköz állapot módosítva erről: {{from}} erre: {{to}} állásidővel: {{downtime}}',
  asset_status_changed_to_by:
    'Eszköz állapot módosítva erre: {{status}} általa: {{user}}',
  asset_status_changed_to_on:
    'Eszköz állapot módosítva erre: {{status}} ekkor: {{date}}',
  asset_status_changed_to_by_on:
    'Eszköz állapot módosítva erre: {{status}} általa: {{user}} ekkor: {{date}}',
  asset_status_changed_to_with_downtime:
    'Eszköz állapot módosítva erre: {{status}} állásidővel: {{downtime}}',
  asset_status_changed_to_by_with_downtime:
    'Eszköz állapot módosítva erre: {{status}} általa: {{user}} állásidővel: {{downtime}}',
  asset_status_changed_to_on_with_downtime:
    'Eszköz állapot módosítva erre: {{status}} ekkor: {{date}} állásidővel: {{downtime}}',
  asset_status_changed_to_by_on_with_downtime:
    'Eszköz állapot módosítva erre: {{status}} általa: {{user}} ekkor: {{date}} állásidővel: {{downtime}}',
  asset_status_changed_by_on:
    'Eszköz állapot módosítva általa: {{user}} ekkor: {{date}}',
  asset_status_changed_by_with_downtime:
    'Eszköz állapot módosítva általa: {{user}} állásidővel: {{downtime}}',
  asset_status_changed_on_with_downtime:
    'Eszköz állapot módosítva ekkor: {{date}} állásidővel: {{downtime}}',
  asset_status_changed_by_on_with_downtime:
    'Eszköz állapot módosítva általa: {{user}} ekkor: {{date}} állásidővel: {{downtime}}',
  asset_status_changed_with_downtime:
    'Eszköz állapot módosítva állásidővel: {{downtime}}',
  asset_status_changed: 'Eszköz állapot módosítva',
  asset_status_changed_from: 'Eszköz állapot módosítva erről: {{from}}',
  asset_status_changed_from_by:
    'Eszköz állapot módosítva erről: {{from}} általa: {{user}}',
  asset_status_changed_from_on:
    'Eszköz állapot módosítva erről: {{from}} ekkor: {{date}}',
  asset_status_changed_from_by_on:
    'Eszköz állapot módosítva erről: {{from}} általa: {{user}} ekkor: {{date}}',
  asset_status_changed_from_with_downtime:
    'Eszköz állapot módosítva erről: {{from}} állásidővel: {{downtime}}',
  asset_status_changed_from_by_with_downtime:
    'Eszköz állapot módosítva erről: {{from}} általa: {{user}} állásidővel: {{downtime}}',
  asset_status_changed_from_on_with_downtime:
    'Eszköz állapot módosítva erről: {{from}} ekkor: {{date}} állásidővel: {{downtime}}',
  asset_status_changed_from_by_on_with_downtime:
    'Eszköz állapot módosítva erről: {{from}} általa: {{user}} ekkor: {{date}} állásidővel: {{downtime}}',
  upgrade_request_received:
    'Frissítési kérelem érkezett! Hamarosan felvesszük veled a kapcsolatot a fizetési részletekkel',
  continue_with_sso: 'Folytatás SSO-val',
  see_live_demo: 'Élő demó megtekintése',
  demo_warning:
    'Ez a példány demó módban van. Ne használd valós adatokhoz! Minden rendszeresen törlésre kerül!',
  Statistics: 'Statisztika',
  requests: 'Kérések',
  assets: 'Eszközök',
  locations: 'Helyszínek',
  parts_and_inventory: 'Alkatrészek / Készlet',
  purchase_orders: 'Beszerzési rendelések',
  meters: 'Mérőórák',
  people_teams: 'Személyek és csapatok',
  vendors_customers: 'Beszállítók és alvállalkozók',
  categories: 'Kategóriák',
  settings: 'Beállítások',
  people: 'Személyek',
  teams: 'Csapatok',
  vendors: 'Beszállítók'
};

export default locale;
